import Base from 'records/Base';
import Design from 'records/Design';

import { REHYDRATE } from 'redux-persist/constants';
import {
  DESIGN_ASYNC_ACTION_START,
  DESIGN_ASYNC_ACTION_SUCCESS,
  DESIGN_ASYNC_ACTION_ERROR,
  DESIGN_UPLOAD_ASYNC_ACTION_SUCCESS,
  DESIGN_UPDATE_ACTION_SUCCESS,
  DESIGN_UPDATE_KEY_ACTION_SUCCESS,
  DESIGN_VERSION_ASYNC_ACTION_SUCCESS,
  DESIGN_UPDATE_ASYNC_ACTION_SUCCESS,
  DESIGN_ARCHIVE_ACTION_SUCCESS,
  DESIGN_RESET_STATE,
  DESIGN_CREATE_MENU_ACTION_SUCCESS,
  DESIGN_ASYNC_MENUTYPE_ERROR,
  DESIGN_RETURN_ACTION_SUCCESS,
  DESIGN_UPDATE_PAGE_ORDINALS_ACTION_SUCCESS,
  DESIGN_UPDATE_PAGE_ORDINALS_ACTION_ERROR,
  DESIGN_ADD_PAGE_ASYNC_ACTION_SUCCESS,
  DESIGN_DELETE_PAGE_ASYNC_ACTION_SUCCESS,
  DESIGNS_SET_DOWNLOAD_STATE,
  DESIGNS_RESET_DOWNLOAD_STATE
} from 'actions/design';
import { DOWNLOAD_STATES } from 'constants/design'

const initialState = new Base({
  loading: false,
  errorMessage: null,
  downloadingState: DOWNLOAD_STATES.IDLE,
  data: new Design(),
});

const loadingSuccess = (state, action) => {
  return state.merge({
    loading: false,
    errorMessage: null,
  });
};

const actionsMap = {
  [DESIGN_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGN_RETURN_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_UPLOAD_ASYNC_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: true,
      errorMessage: action.error,
    });
  },
  [DESIGN_ASYNC_MENUTYPE_ERROR]: (state, action) => {
    return state.merge({
      loading: true,
      errorMessage: action.error,
    });
  },
  [DESIGN_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Design(action.data),
    });
  },
  [DESIGN_VERSION_ASYNC_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_UPDATE_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const { title } = action.data;
    let designData = state.get('data');
    designData = designData.set('title', title);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: designData,
    });
  },
  [DESIGN_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [DESIGN_UPDATE_KEY_ACTION_SUCCESS]: (state, action) => {
    const newDesign = state.get('data').updateDesignKey(action.key, action.value);
    return state.merge({
      loading: false,
      data: newDesign,
    });
  },
  [DESIGN_ARCHIVE_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_RESET_STATE]: () => {
    return initialState;
  },
  [DESIGN_CREATE_MENU_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_UPDATE_PAGE_ORDINALS_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_UPDATE_PAGE_ORDINALS_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGN_ADD_PAGE_ASYNC_ACTION_SUCCESS]: loadingSuccess,
  [DESIGN_DELETE_PAGE_ASYNC_ACTION_SUCCESS]: loadingSuccess,
  [REHYDRATE]: (state, action) => {
    const designPayload = action.payload.design;
    if (designPayload) {
      const designData = new Design(designPayload.data);
      return new Base({
        loading: designPayload.loading,
        errorMessage: designPayload.errorMessage,
        data: designData,
      });
    }
    return state;
  },
  [DESIGNS_SET_DOWNLOAD_STATE]: (state, action) => {
    return state.merge({
      downloadingState: action.state
    });
  },
  [DESIGNS_RESET_DOWNLOAD_STATE]: (state) => {
    return state.merge({
      downloadingState: DOWNLOAD_STATES.IDLE
    });
  }
};

export default function design(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
